import { Icon } from "./Icon";
export const IconRefresh = (props) => (
  <Icon {...props}>
    <path d="M2.5 2v6h6M21.5 22v-6h-6" />
    <path d="M22 11.5A10 10 0 0 0 3.2 7.2M2 12.5a10 10 0 0 0 18.8 4.2" />
  </Icon>
);
